import { render, staticRenderFns } from "./DailyComparisonCardDbmRisk.vue?vue&type=template&id=5a25b8da"
import script from "./DailyComparisonCardDbmRisk.vue?vue&type=script&lang=js"
export * from "./DailyComparisonCardDbmRisk.vue?vue&type=script&lang=js"
import style0 from "./DailyComparisonCardDbmRisk.vue?vue&type=style&index=0&id=5a25b8da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports